import React from "react";
import "./footer.scss";
import logo from "../../Media/Logo_Greenbay (1).png";
import {Link} from "react-router-dom";

const footer = () => {
  return (
    <div className="container-footer">
      <div className="container-atas">
        <div className="container-logo">
          <img className="gambar-logo" src={logo} alt="logo-Parkspring" />
        </div>
        <div className="container-deskripsi">
          <div className="alamat">
            <h1>Marketing Gallery</h1>
            <h2>Apartement Greenbay Pluit</h2>
            <h3>Sewa Harian, Bulanan, Tahunan Apartemen Greenbay Pluit</h3>
            <h4>Contact us : +6283879132458</h4>
            <Link to="/privacy-policy">
              <div className="footer-contact">Privacy Policy</div>
            </Link>
          </div>
          <div className="privasi"></div>
        </div>
      </div>
      <div className="container-bawah">
        <div className="rights">© Apartemen Greenbay Pluit</div>
        <div className="powered">Powered by Linktown</div>
      </div>
    </div>
  );
};

export default footer;
